module.exports = __webpack_public_path__ + "img/112.10.4e69243c.png";